<template>
  <div class="printContainer" id="printContainer" :class="[os, $route.params.papersize, (data!=null)?data.size:'abc']">
    <div class="printScreen" :style="{border: (showPrintBtn?'1px solid #000':'none')}">
      <img src="https://app.brighton.com/lockets/img/brighton_logo.jpg" alt="Brighton.com" class="logo">
      <span class="title"><span class="text">Your Design Confirmation Is </span><span class="confirmationNum">{{$route.params.confirmationNum.replace('LOCKETS-', '')}}</span></span>
      <hr>
       <span class="t1">The image below has been resized for insertion in the {{name}}. </span><br/>
       <span class="small">We will keep your design in our system until {{keepPrintoutUntilDate}}</span>
      <div class="locket" v-if="data != null && (data.size == 's' || data.size == 'l')">
        <!-- print left side-->
        <div class="img left" v-if="data.sides == 2" >
          <span class="text" :class="{small: data.size=='s', large: data.size=='l'}" v-if="data.userInputType2 == 2">
            <span :style="{'font-family': data.userInputTextFontFamily2}">{{data.userInputText4}}</span>
            <span :style="{'font-family': data.userInputTextFontFamily2}">{{data.userInputText5}}</span>
            <span :style="{'font-family': data.userInputTextFontFamily2}">{{data.userInputText6}}</span>
          </span>
          <img @load="numImgLoaded++" v-if="data.userInputType2 == 2" :src="data.styleImage2" :style="printImageCSS" alt="" class="left"/>
          <div v-else>
            <img @load="numImgLoaded++" v-if="data.settingJsonPreview2 == ''"  :src="data.previewFileName2" :style="printImageCSS" alt="" class="left"/>
            <div :style="printImageCSS" v-else><canvas id = "leftSide" ></canvas></div>
          </div>
        </div>
        <!-- if one sided we want to print the right side twice-->
        <div class="img left" v-if="data.sides == 1" :style={}>
          <span class="text" :class="{small: data.size=='s', large: data.size=='l'}" v-if="data.userInputType1 == 2">
            <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText1}}</span>
            <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText2}}</span>
            <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText3}}</span>
          </span>
          <img @load="numImgLoaded++" v-if="data.userInputType1 == 2" :src="data.styleImage1" :style="printImageCSS" alt="" class="right"/>
          <div v-else>
            <img @load="numImgLoaded++" v-if="data.settingJsonPreview1 == ''"  :src="data.previewFileName1" :style="printImageCSS" alt="" class="right"/>
            <div :style="printImageCSS" v-else><canvas id = "rightSide1" ></canvas></div>
          </div>
        </div>
        <!-- print right side-->
        <div class="img right">
          <span class="text" :class="{small: data.size=='s', large: data.size=='l'}" v-if="data.userInputType1 == 2">
            <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText1}}</span>
            <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText2}}</span>
            <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText3}}</span>
          </span>
          <img @load="numImgLoaded++" v-if="data.userInputType1 == 2" :src="data.styleImage1" alt="" :style="printImageCSS" class="right"/>
          <div v-else>
            <img @load="numImgLoaded++" v-if="data.settingJsonPreview1 == ''" :src="data.previewFileName1" :style="printImageCSS" alt="" class="right"/>
            <div :style="printImageCSS" v-else><canvas id = "rightSide" ></canvas></div>
          </div>
        </div>
      </div>
     
     
     
      <div class="locket xlarge" v-else-if="data != null && data.size == 'xl'">
        
        <div v-for="side in parseInt(data.sides)" class="img right" style="width: 100%;">
            <span class="text xlarge" v-if="data['userInputType' + (side)] == 2">
              <span :style="{'font-family': data['userInputTextFontFamily'+side]}">{{data['userInputText' + ((side + (2 * (side -1))) + 0)]}}</span>
              <span :style="{'font-family': data['userInputTextFontFamily'+side]}">{{data['userInputText' + ((side + (2 * (side -1))) + 1)]}}</span>
              <span :style="{'font-family': data['userInputTextFontFamily'+side]}">{{data['userInputText' + ((side + (2 * (side -1))) + 2)]}}</span>
            </span>
            <img @load="numImgLoaded++" v-if="data['userInputType' + (side)] == 2" :src="data['styleImage'+(side)]" alt="" :style="printImageCSS" class="right"/>
            <div v-else>
              <img @load="numImgLoaded++" v-if="data['settingJsonPreview' + (side)] == ''" :src="data['previewFileName' + (side)]" :style="printImageCSS" alt="" class="right"/>
              <div :style="printImageCSS" v-else><canvas :id = "'oneSide'+(side-1)" ></canvas></div>
            </div>
          </div>
      </div>



      <div class="locket xxlarge" v-else-if="data != null && data.size == 'xxl'">
        <div class="img right" style="width: 100%;">
          <span class="text xxlarge" v-if="data.userInputType1 == 2">
            <span :style="{'font-family': data['userInputTextFontFamily'+side]}">{{data.userInputText1}}</span>
            <span :style="{'font-family': data['userInputTextFontFamily'+side]}">{{data.userInputText2}}</span>
            <span :style="{'font-family': data['userInputTextFontFamily'+side]}">{{data.userInputText3}}</span>
          </span>
          <img @load="numImgLoaded++" v-if="data.userInputType1 == 2" :src="data.styleImage1" alt="" :style="printImageCSS" class="right"/>
          <div v-else>
            <img @load="numImgLoaded++" v-if="data.settingJsonPreview1 == ''" :src="data.previewFileName1" :style="printImageCSS" alt="" class="right"/>
            <div :style="printImageCSS" v-else><canvas id = "oneSide"></canvas></div>
          </div>
        </div>
      </div>



      <ul class="instructions">
        <li class="t1">Great job! To personalize your locket/accessory with your photo, simply do one of the following:</li>
        <!-- <li class="t2">•  Order your locket and we will insert the photo for you. <span v-if="showPrintBtn" @click="print()"><button>PRINT</button></span></li> -->
        <!-- <li><center>or</center></li>   -->
        <li class="t2">•  Print this confirmation and take it to a local Brighton retailer. They will be happy to print and insert your photo into your locket/accessory.</li>
        <li><center>or</center></li> 
        <li class="t3">•  Feeling creative? Simply print and cut the photo at home for insertion. </li>
      </ul>
    </div>
    <button v-if="showPrintBtn" style="margin-top:20px"  @click="closeThis()">Close</button>
    <!-- <span>{{os}}</span> -->
    <!-- <span>{{printImageCSS}}</span> -->
  </div>
</template>

<script>
// import html2canvas from 'html2canvas'
export default {
  name: 'Print',
  props: {
    // msg: String
    // papersize: String
  },
  data: function () {
    return {
      os: null,
      leftLocket: '',
      showPrintBtn: true,
      rightLocket: '',
      printWidth: 0,
      userInputText1:'',
      userInputText2:'',
      userInputText3:'',
      userInputText4:'',
      userInputText5:'',
      userInputText6:'',
      userInputTextFontFamily1:'',
      userInputTextFontFamily2: '',
      userInputType: 1,
      name: '',
      data: null,
      numImgLoaded: 0,
      canvasLoaded: 0
    }
  },
  watch: {
    canvasLoaded (newValue) {
      if(
          (this.data.sides == 1 && (this.data.size == 'xl' || this.data.size == 'xxl') && ((newValue / 2) + this.numImgLoaded >= 1))
          ||
          (this.data.sides == 1 && (this.data.size == 'l' || this.data.size == 's') && ((newValue / 2) + this.numImgLoaded >= 2))
          ||
          (this.data.sides == 2 && ((newValue / 2) + this.numImgLoaded >= 2))
          ||
          (this.data.sides > 2 && ((newValue / 2) + this.numImgLoaded >= 4))
        )
      {  
        this.$forceUpdate()
        this.print()
      } 
    },
    numImgLoaded (newValue) {
      if(
          (this.data.sides == 1 && (this.data.size == 'xl' || this.data.size == 'xxl') && ((newValue / 2) + this.numImgLoaded >= 1))
          ||
          (this.data.sides == 1 && (this.data.size == 'l' || this.data.size == 's') && ((newValue / 2) + this.numImgLoaded >= 2))
          ||
          (this.data.sides == 2 && ((newValue / 2) + this.numImgLoaded >= 2))
          ||
          (this.data.sides > 2 && ((newValue / 2) + this.numImgLoaded >= 4))
        )
      {  
        this.$forceUpdate()
        this.print()
      } 
    }
  },
  computed: {
   keepPrintoutUntilDate () {
     if(this.data!= null) {
      var date = new Date(this.data.createDate.replace(/-/g, "/"));
      date.setDate(date.getDate() + 15);
      this.$forceUpdate()
      return date.getMonth()+ 1+'/'+date.getDate()+ '/'+date.getFullYear()
     }
    },
    printImageCSS() {
      if(this.data != null && this.data.printWidth != 0 && this.data.printWidth != null) {
        var width = this.data.printWidth
        var height = this.data.printHeight
        if(this.os == 'iOS' || this.os == 'MacOS') {
          width = width - 0.1
          height = height - 0.1
        }
        return {
          width: width + 'cm',
          height: (height > 0 ? height : width) + 'cm',
          // height: 'auto',
          margin: '0 auto'
        }
      } else {
        return {
          width: 'auto',
          height:'auto',
          margin: '0 auto'
        }
      }
    }
  },
  methods: {
    closeThis() {
      window.close()
    },
    print() {
      var that = this
      this.showPrintBtn = false;
      this.$forceUpdate()
      this.$nextTick(function (){
        window.print()
        that.showPrintBtn = true;
      });
    },
   pullOrder() {
    var that = this;
    this.$http.post(
      'https://app.brighton.com/lockets/api/getOrder',
      {confirmationNum: this.$route.params.confirmationNum},
      {emulateJSON: true}
    ).then(response => {
        this.name = response.data.data[0].name;
        this.data = response.data.data[0];
        this.$nextTick(() =>{
          
          if(this.data['size'] == 's' || this.data['size'] == 'l') {
            if(this.data['userInputType1']!=2) {
              this.setPreviewUserImgOne(0, 'rightSide')
              // if this is a one-sided locket then need to print right side twice
              if(this['data'].sides == 1){
                this.setPreviewUserImgOne(0, 'rightSide1') // for right side 2
              }
            }
            if(this.data['sides'] > 1 && this.data['userInputType2']!=2){
              this.setPreviewUserImgOne(1, 'leftSide')
            }
          } else if(this.data['size'] == 'xxl') {
            this.setPreviewUserImgOne(0, 'oneSide')
          } else if(this.data['size'] == 'xl') {
            for(let side = 0; side < parseInt(this.data['sides']); side ++) {
              if(this.data['userInputType' + (side + 1)] != 2 ) 
                this.setPreviewUserImgOne(side, 'oneSide'+ (side))
            }
          }
        })
    }, response => {
      // error callback
    });
   },
   setPreviewUserImgOne(side=0, canvasID){
      console.log(side, canvasID, 'settingJsonPreview'+(side+1))
      // let canvasID = (side==1)?'leftSide':(side==0)?'rightSide':'rightSide1'
      // let canvasID = canvasID
      fabric.textureSize = 6144
      let canvas = new fabric.Canvas(canvasID)
     
      let jsonsetting = this.data['settingJsonPreview'+(side+1)].substr(1)
      jsonsetting = jsonsetting.substring(0, jsonsetting.length -1)
      jsonsetting = JSON.parse(jsonsetting)

      canvas.loadFromJSON(jsonsetting, (x)=> {
        if(this.data['maskSizeHeight'] != 0)
          canvas.setHeight(parseInt(this.data['maskSizeHeight']) + 0)
        else
          canvas.setHeight(parseInt(this.data['maskSize']) + 0)
        canvas.setWidth(parseInt(this.data['maskSize']) - 0)
        $('.canvas-container').css('max-width', '100%')
        if(document.querySelector("#"+canvasID) != null) {
          document.querySelector("#"+canvasID).style.width = '100%'
          document.querySelector("#"+canvasID).style.height = '100%'
        }
        let canvasContainers = document.querySelectorAll('.canvas-container')
        for(let i = 0; i < canvasContainers.length; i ++) {
          canvasContainers[i].style.width = '100%'
          canvasContainers[i].style.height = '100%'
        }
        let upperCanvases = document.querySelectorAll('.upper-canvas')
        for(let i = 0; i < upperCanvases.length; i ++) {
          upperCanvases[i].style.width = '100%'
          upperCanvases[i].style.height = '100%'
        }
      });
      canvas.on('after:render', ()=> this.canvasLoaded++)
		}
  },
  mounted: function() {
    // console.log('mounted print')
    this.pullOrder();
    var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      this.os = 'MacOS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      this.os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      this.os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      this.os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      this.os = 'Linux';
    }
  }
}
</script>
<style>
  body, html{
    margin: 0 !important;
    padding: 0 !important;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body, html{
  margin: 0 !important;
}
@page {
  /* size: 4in 6in; */
  /* size: 2.1in 3.4in; */
  size: 3.94in 5.83in;
  margin: 0;
}
@media all  {
  .printContainer{
    display:block;
    text-align:right;
    max-width:800px;
    margin:0 auto;
  }
  .printContainer .printScreen .logo{
    display:block;
    width:40%;
    margin:10px auto;
  }
  .printContainer .printScreen{
    text-align:center;
    display:block;
    padding:10px 20px;
    box-sizing: border-box;
    margin:0 auto;
    border:1px solid #999; 
  }
  .printContainer .printScreen{
    /* width:500px; */
  }
  .printContainer .printScreen hr{
    width:90%;
  }
  .printContainer .printScreen .locket{
    display: flex; /* or inline-flex */
    justify-content: center;
    webkit-box-pack: space-evenly;
    -ms-flex-pack: space-evenly;
    text-align:center;
    margin-top:30px;
    position:relative;
  }
  .printContainer .printScreen .locket:after{
    content: '';
    z-index:4;
    width:100%;
    height:100%;
    position:absolute;
    top:0;
    left:0;
  }
  .printContainer .printScreen .locket.xlarge{
    display: block;
  }
  .printContainer .printScreen .locket.xlarge .img{
    page-break-after: always; 
    display: block;
  }
  .printContainer .printScreen .locket.xxlarge{
    page-break-before: always; 
  }
  .printContainer.iOS .printScreen .locket{
    margin-top:0;
  }
  .printContainer .printScreen .locket .img{
    display:inline-block;
    width:50%;
    position:relative;
  }
  .printContainer .printScreen .locket .img img{
    display:block;
    margin:0 auto;
  }
  .printContainer .printScreen .locket .img .text{
    position: absolute;
    left:0;
    text-align: center;
    font-size:0.9em;
    top:27%;
    width:100%;
    line-height:1.3;
  }
  .printContainer .printScreen .locket .img .text.xlarge {
      top:28%;
  }
  .printContainer .printScreen .locket .img .text.large {
      top:28%;
  }
  .printContainer .printScreen .locket .img .text.small{
    top:32%;
  }
  .printContainer .printScreen .locket .img .text span{
    display:block;
  }
  .printContainer .printScreen .locket .img .text.xxlarge span{
    height: 50px;
  font-size: 54px;
  }
  .printContainer .printScreen .locket .img .text.xlarge span{
    height:28px; /* fixed height */
    font-size:30px;
  }
  .printContainer .printScreen .locket .img .text.small span{
    line-height:11px;
    font-size:11px;
    height:auto; /* fixed height */
    font-weight:bold;
  }
  .printContainer .printScreen .locket .img .text.large span{
    height:18px; /* fixed height */
    font-size:14px;
  }


  .printContainer .title{
    font-weight: bold;
    display:block;
    font-size:18px;
    padding:0;
  }
  .printContainer .title .confirmationNum{
    color:#e03c7f;
  }
  .printContainer .instructions{
    text-align: left;
    margin-top:20px;
    margin-left:0;
    padding-left:0;
    font-size:14px;
    list-style: none;
    margin-bottom:0;
  }



 
  .printContainer .instructions li{
    padding:4px 0;
  }
  .printContainer .instructions .t1{
    font-weight: bold;
    display:block;
  }
  .printContainer .instructions .t2{
    display:block;
  }
  .printContainer .instructions .t3{
    display: block;
  }

  /* now for small size print paper*/
  .printContainer.small .printScreen{
    border:none;
    margin-top:5px;
  }
  .printContainer.small .logo{
    display:none;
  }
  .printContainer.small hr{
    display:none;
  }
  .printContainer.small .title {
    /*font-size:10px;*/
    margin:10px 0;
    font-size:13px;
  }
  .printContainer.small .title .text{
    /*display:none;*/
    line-height:1;
  }
  .printContainer.small .t1{
    display:none;
  }
  .printContainer.small .locket{
    display:block;
    margin:0 auto;
  }
  .printContainer.small .locket .img{
    display:block;
    margin:15px auto 0 auto;
    width:auto;
  }
  .printContainer.small.s .locket .img{
    margin-top: 25px;
  }
  .printContainer.small .instructions{
    display:none;
  }
}


 /* platform specific*/
 .printContainer.MacOS .printScreen,
 .printContainer.iOS .printScreen,
 .printContainer.Android .printScreen{
   width:100%;
   padding:10px 0;
 }
.printContainer.iOS .logo{
}
.printContainer.MacOS .title,
.printContainer.Android .title,
.printContainer.iOS .title{
  font-size:12px;
  line-height:1
}
.printContainer.MacOS .instructions,
.printContainer.Android .instructions,
.printContainer.iOS .instructions{
  margin-top:0;
  display:none;
}
.printContainer.MacOS .t1,
.printContainer.Android .t1,
.printContainer.iOS .t1,
.printContainer.MacOS .instructions .t1,
.printContainer.Android .instructions .t1,
.printContainer.iOS .instructions .t1{
  display:none
}
.printContainer.MacOS .printScreen .locket,
.printContainer.Android .printScreen .locket,
.printContainer.iOS .printScreen .locket{
  display:block
}
/* .printContainer.Windows .printScreen .locket .img, */
.printContainer.MacOS .printScreen .locket .img,
.printContainer.Android .printScreen .locket .img,
.printContainer.iOS .printScreen .locket .img{
  display:block;
  width:100%;
  margin-bottom:5px;
}
@media(max-width:505px) {
  .home .main .right .container{
    padding:0 20px;
  }
}
</style>
